export const FindById = async (resource, id) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/find_by_id/${id}`).then(
    (response) => {
      result = response.body.data[0];
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const deleteInterconsult = async (resource, id) => {
  let result;
  await resource.delete(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/${id}`).then(
    (response) => {
      result = response.status;
      console.log(response);
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const saveInterconsult = async (resource, data) => {
  let result;
  await resource.post(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult`, data).then(
    (response) => {
      result = response;
      // this.toast("la interconsulta fue creada con exito", "is-success");
    },
    (response) => {
      result = response;
    }
  );
  return result;
};

export const getInterconsult = async (resource, id) => {
  let result;
  console.log(id);
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/${id}`).then(
    (response) => {
      // success callback
      result = response.body.interconsult[0];
    },
    (response) => {
      console.log(response);
      // error callback
    }
  );
  return result;
};

export const putInterconsult = async (resource, id, data) => {
  let result;
  await resource.put(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/${id}`, data).then(
    (response) => {
      result = response.status;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const searchInterconsultByRut = async (resource, rut) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/find_by_rut_pasive/${rut}`).then(
    (response) => {
      result = response.body.data;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const getInterconsultByRut = async (resource, rut) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/find_by_rut/${rut}`).then(
    (response) => {
      // success callback
      result = response.body.data;
    },
    (response) => {
      console.log(response);
      // error callback
    }
  );
  return result;
};
/**
 *
 * @param {*} resource
 * @param {string} state state definido en el state_interconsult
 * @param {string} step step definido en el state_interconsult
 * @param {number} destination_node_id destination_node_id de interconsult
 * @returns
 */
export const findByStateStep = async (resource, state, step, destination_node_id) => {
  let result;
  await resource
    .get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/find_by_state_step/${state}/${step}/${destination_node_id}`)
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};
/**
 *
 * @param {*} resource
 * @param {string} state state definido en el state_interconsult
 * @param {string} step step definido en el state_interconsult
 * @param {number} origin_node_id origin_node_id de interconsult
 * @returns
 */
export const findByStateStepOriginPage = async (resource, state, step, origin_node_id, order, page) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(
        localStorage.getItem("perfil")
      )}interconsult/find_by_state_step_origin_paginate/${state}/${step}/${origin_node_id}/${order}?page=${page}`
    )
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};
/**
 *
 * @param {*} resource
 * @param {string} state state definido en el state_interconsult
 * @param {string} step step definido en el state_interconsult
 * @param {number} destination_node_id destination_node_id de interconsult
 * @returns
 */
export const findByStateStepPage = async (resource, state, step, destination_node_id, order, page) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(
        localStorage.getItem("perfil")
      )}interconsult/find_by_state_step_paginate_by_order/${state}/${step}/${destination_node_id}/${order}?page=${page}`
    )
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};
/**
 *
 * @param {*} resource
 * @param {string} state state definido en el state_interconsult
 * @param {string} step step definido en el state_interconsult
 * @param {number} specialty_id specialty_id asociado a la interconsulta
 * @param {number} destination_node_id destination_node_id de interconsult
 * @returns
 */
export const findByStateStepSpecialtyPage = async (resource, state, step, specialty_id, destination_node_id, page) => {
  let result;
  await resource.get(`api/interconsult/find_by_state_step_specialty_paginate/${state}/${step}/${specialty_id}/${destination_node_id}?page=${page}`).then(
    (response) => {
      // success callback
      result = response.body;
    },
    (response) => {
      console.log(response);
      // error callback
    }
  );
  return result;
};
/**
 *
 * @param {*} resource
 * @param {string} state state definido en el state_interconsult
 * @param {string} step step definido en el state_interconsult
 * @param {number} specialty_id specialty_id asociado a la interconsulta
 * @param {number} destination_node_id destination_node_id de interconsult
 * @param {number} page
 * @returns
 */
export const findByStateStepSpecialtyNodePage = async (resource, state, step, specialty_id, destination_node_id, page) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(
        localStorage.getItem("perfil")
      )}interconsult/find_by_state_step_specialty_node_paginate/${state}/${step}/${specialty_id}/${destination_node_id}?page=${page}`
    )
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};
/**
 *
 * @param {*} resource
 * @param {string} state state definido en el state_interconsult
 * @param {string} step step definido en el state_interconsult
 * @param {number} specialty_id specialty_id asociado a la interconsulta
 * @param {number} destination_node_id destination_node_id de interconsult
 * @returns
 */
export const findByStateStepSpecialty = async (resource, state, step, specialty_id, destination_node_id) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(
        localStorage.getItem("perfil")
      )}interconsult/find_by_state_step_specialty/${state}/${step}/${specialty_id}/${destination_node_id}`
    )
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};

/**
 *
 * @param {*} resource
 * @param {string} state state definido en el state_interconsult
 * @param {string} step step definido en el state_interconsult
 * @param {number} destination_node_id destination_node_id de interconsult
 * @param {number} specialty especialidad de la interconsulta
 * @param {number} rut rut del paciente en la interconsulta
 * @returns
 */
export const findByStateStepDestinationRut = async (resource, state, step, destination_node_id, specialty, rut, page) => {
  let result;
  await resource
    .get(`api/interconsult/find_by_state_step_specialty_rut_paginate/${state}/${step}/${specialty}/${destination_node_id}/${rut}?page=${page}`)
    .then(
      (response) => {
        // success callback
        result = response.body.data;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};

/**
 *
 * @param {*} resource
 * @param {*} id EL user_id que crea la IC (por ahora solo ocurre cuando natales crea una IC)
 * @returns
 */
export const getInterconsultByUserId = async (resource, id) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/user_id/${id}`).then(
    (response) => {
      // success callback
      result = response.body;
    },
    (response) => {
      console.log(response);
      // error callback
    }
  );
  return result;
};

/**
 *
 * @param {*} resource
 * @param {String} rut rut del paciente asociado a la interconsulta
 * @returns Interconsultas asociadas al paciente, estan con paginación
 */
export const getInterconsultByRutPage = async (resource, rut, page) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/find_by_patient_paginate/${rut}?page=${page}`).then(
    (response) => {
      // success callback
      result = response.body;
    },
    (response) => {
      console.log(response);
      // error callback
    }
  );
  return result;
};

/**
 *
 * @param {*} resource
 * @param {*} user_id el user_id de la IC
 * @param {*} state el state de la IC
 * @returns
 */
export const getInterconsultByUserIdAndState = async (resource, user_id, state) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/find_by_user_id_state/${state}/${user_id}`).then(
    (response) => {
      // success callback
      result = response.body.data;
    },
    (response) => {
      console.log(response);
      // error callback
    }
  );
  return result;
};

/**
 *
 * @param {*} resource
 * @param {*} destination_node_id el destination_node_id de la IC
 * @param {*} state el state de la IC
 * @returns
 */
export const getInterconsultByStateAndDestination = async (resource, destination_node_id, state, page) => {
  let result;
  await resource
    .get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/find_by_state_destination/${state}/${destination_node_id}?page=${page}`)
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};

/**
 *
 * @param {*} resource
 * @param {*} destination_node_id el destination_node_id de la IC
 * @param {*} state el state de la IC
 * @returns
 */
export const getInterconsultBySpecialtyStateAndDestination = async (resource, specialty, state, destination_node_id, page) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(
        localStorage.getItem("perfil")
      )}interconsult/find_by_specialty_state_destination/${specialty}/${state}/${destination_node_id}?page=${page}`
    )
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};

/**
 *
 * @param {*} resource
 * @param {*} destination_node_id el destination_node_id de la IC
 * @param {*} state el state de la IC
 * @returns
 */
export const getInterconsultBySpecilatyStateDestinationRut = async (resource, specialty, state, destination_node_id, rut, page) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(
        localStorage.getItem("perfil")
      )}interconsult/find_by_specialty_state_destination_rut/${specialty}/${state}/${destination_node_id}/${rut.replace(/[.-]/g, "")}?page=${page}`
    )
    .then(
      (response) => {
        // success callback
        result = response.body.data;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};

export const getInterconsultByStateDestinationRut = async (resource, state, destination_node_id, rut, page) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(
        localStorage.getItem("perfil")
      )}interconsult/find_by_state_destination_rut/${state}/${destination_node_id}/${rut}?page=${page}`
    )
    .then(
      (response) => {
        // success callback
        result = response.body.data;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};

/**
 *
 * @param {*} resource
 * @param {string} state Estado del state_interconsult
 * @param {number} node_id id del establecimiento con el que se ingresa, se revisa tanto origen como destination
 * @param {number} page
 * @returns
 */
export const findByStateNode = async (resource, state, node_id, page) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/find_by_state_node/${state}/${node_id}?page=${page}`).then(
    (response) => {
      // success callback
      result = response.body;
    },
    (response) => {
      console.log(response);
      // error callback
    }
  );
  return result;
};
export const findByStateNodeByOrder = async (resource, state, node_id, order, page) => {
  let result;
  await resource
    .get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/find_by_state_node_by_order/${state}/${node_id}/${order}?page=${page}`)
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};
/**
 *
 * @param {*} resource
 * @param {string} state Estado del state_interconsult
 * @param {number} node_id id del establecimiento con el que se ingresa, se revisa tanto origen como destination
 * @param {number} specialty_id id de la especialidad sigte
 * @param {number} page
 * @returns
 */
export const findByStateNodeSpecialty = async (resource, state, specialty_id, node_id, page) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/find_by_state_specialty_node/${state}/${specialty_id}/${node_id}?page=${page}`
    )
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};

export const updateStateInterconsult = async (resource, interconsult_id, state) => {
  let result;
  await resource
    .put(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/update_state/` + interconsult_id, {
      state: state,
    })
    .then(
      (response) => {
        // success callback
        result = response.body.interconsult;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};

export const getIcByStateDestinationPatient = async (resource, state, destination_node_id, patient_id, page = 1) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(
        localStorage.getItem("perfil")
      )}interconsult/find_by_state_destination_patient_id/${state}/${destination_node_id}/${patient_id}?page=${page}`
    )
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};

export const getIcByStateDestinationOrOriginPatient = async (resource, state, destination_node_id, patient_id, page = 1) => {
  let result;
  await resource
    .get(`api/interconsult/find_by_state_origin_destination_node_id_patient_id_paginate_or/${state}/${destination_node_id}/${patient_id}?page=${page}`)
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};

export const getIcBySpecialtyStateDestinationPatient = async (resource, specialty_id, state, destination_node_id, patient_id, page = 1) => {
  let result;
  await resource
    .get(`api/interconsult/find_by_specialty_state_destination_patient_id/${specialty_id}/${state}/${destination_node_id}/${patient_id}?page=${page}`)
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};

/**
 *
 * @param {*} resource
 * @param {string} state
 * @param {string} step
 * @param {number} origin_id
 * @param {number} patient_id
 * @param {*} page
 * @returns
 */
export const findByStateStepOriginPatientPaginate = async (resource, state, step, origin_id, patient_id, page = 1) => {
  let result;
  await resource.get(`api/interconsult/find_by_state_step_origin_patient_id_paginate/${state}/${step}/${origin_id}/${patient_id}?page=${page}`).then(
    (response) => {
      // success callback
      result = response.body;
    },
    (response) => {
      console.log(response);
      // error callback
    }
  );
  return result;
};

/**
 *
 * @param {*} resource
 * @param {string} state
 * @param {string} step
 * @param {number} destination_id
 * @param {number} patient_id
 * @param {number} page
 * @returns
 */
export const findByStateStepPatientPaginate = async (resource, state, step, destination_id, patient_id, page = 1) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(
        localStorage.getItem("perfil")
      )}interconsult/find_by_state_step_patient_id_paginate/${state}/${step}/${destination_id}/${patient_id}?page=${page}`
    )
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};

/**
 *
 * @param {*} resource
 * @param {string} state
 * @param {number} node_id
 * @param {number} patient_id
 * @param {number} page
 * @returns
 */
export const findByStateNodePatient = async (resource, state, node_id, patient_id, page = 1) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/find_by_state_node_patient_id/${state}/${node_id}/${patient_id}?page=${page}`
    )
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};

/**
 *
 * @param {*} resource
 * @param {string} state state definido en el state_interconsult
 * @param {string} step step definido en el state_interconsult
 * @param {number} destination_node_id destination_node_id de interconsult
 * @returns
 */
export const findByStateStepOr = async (resource, state, step, destination_or_origin_node_id, order, page = 1) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(
        localStorage.getItem("perfil")
      )}interconsult/find_by_state_step_or/${state}/${step}/${destination_or_origin_node_id}/${order}?page=${page}`
    )
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};

export const findByRutAndServiceNodeId = async (resource, rut, service_node_id) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsult/find_by_rut_by_service_node_id/${rut}/${service_node_id}`).then(
    (response) => {
      // success callback
      result = response.body;
    },
    (response) => {
      console.log(response);
      // error callback
    }
  );
  return result;
};
export const postUploadFileInterconsult = async (resource, data, header = {}) => {
  let result;
  await resource.post(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsults_files`, data, header).then(
    (response) => {
      result = response.body.interconsults_files;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const getInterconsultsFileById = async (resource, interconsult_id) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsults_files/find_by_interconsult_id/${interconsult_id}`).then(
    (response) => {
      result = response.body.interconsult_file;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};
export const postFileInterconsultText = async (resource, data) => {
  let result;
  await resource.post(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}interconsults_files/new_store`, data).then(
    (response) => {
      result = response.body.interconsults_files;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};
export const findByStateStepOriginPageOrder = async (resource, state, step, origin_node_id, order, page) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(
        localStorage.getItem("perfil")
      )}interconsult/find_by_state_step_origin_paginate_by_order/${state}/${step}/${origin_node_id}/${order}?page=${page}`
    )
    .then(
      (response) => {
        // success callback
        result = response.body;
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};
